export default __webpack_public_path__ + "static/media/26.9e8b7bb0.mp3";